import axios from "axios";

import { headers, salesServiceUrl } from '../../config';

export function getCastTypes() {
    return axios.get(`${salesServiceUrl}/cast-types`, { headers: headers() });
}